'use client';

import React, { useState, useEffect } from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import HeroSection from './components/HeroSection';
import BooksShelf from './components/BooksShelf';
import CriticalPraise from './components/CriticalPraise';
import AuthorStudy from './components/AuthorStudy';
import ScrollProgress from './components/ScrollProgress';

export default function HomePage() {
  // Scroll reveal observer
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('active');
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    );

    const revealEls = document.querySelectorAll('.reveal, .reveal-left, .reveal-scale');
    revealEls?.forEach((el) => observer?.observe(el));

    return () => observer?.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-obsidian">
      <ScrollProgress />
      <Header />

      <main>
        <HeroSection />

        <div id="services">
          <BooksShelf />
        </div>

        <CriticalPraise />

        <div id="about">
          <AuthorStudy />
        </div>
      </main>

      <Footer />
    </div>
  );
}